import Data from "../types/Data";
import { getHardcodedGroups } from "./getHardcodedGroups";

export default function getAllGroupsById(data: Data) {
  return { ...getHardcodedGroups(data), ...data.Group };
}
